// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-4ab8b51a-6aa3-459c-9e61-8a1e4824ae34-" + {586: "c5f47877bf1fa470",621: "56f7b279e94d3837",}[chunkId] + ".js"
}